/* Карточка в правой колонке дашборда — в том же виде, что «Замечания». */
.card {
  padding: 18px 18px 14px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }

.title { margin: 0; font-size: 16px; font-weight: 600; color: var(--text); }

.scope { font-size: 12.5px; color: var(--text2); }

.totals { margin: 12px 0 0; }

.total {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid var(--border);
}

.total:last-child { border-bottom: none; }
.total dt { font-size: 13.5px; color: var(--text); }
.total dd { margin: 0; font-size: 15px; font-weight: 650; color: var(--text); font-variant-numeric: tabular-nums; }

.added { color: var(--err) !important; }
.fixed { color: var(--ok) !important; }

.divs {
  width: 100%;
  margin-top: 10px;
  font-size: 12.5px;
  border-collapse: collapse;
}

.divs th {
  padding: 6px 4px;
  font-weight: 600;
  color: var(--text2);
  text-align: right;
  border-bottom: 1px solid var(--border);
}

.divs td {
  padding: 5px 4px;
  color: var(--text);
  text-align: right;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid var(--border);
}

.divs th:first-child,
.divs td:first-child { text-align: left; }
.divs tr:last-child td { border-bottom: none; }

.subtitle { margin: 16px 0 6px; font-size: 13px; font-weight: 600; color: var(--text2); }

.recent { margin: 0 -8px; padding: 0; list-style: none; }

.item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 7px 8px;
  text-align: left;
  color: var(--text);
  background: none;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.item:hover { background: var(--table-hover); }
.item:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; }

.itemTop { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.itemName { overflow: hidden; font-size: 13px; font-weight: 500; text-overflow: ellipsis; white-space: nowrap; }
.itemAgo { flex-shrink: 0; font-size: 12px; color: var(--text2); }
.itemIssue { font-size: 12.5px; color: var(--err); }
.itemFixed { color: var(--text2); text-decoration: line-through; text-decoration-thickness: 1px; }

.quiet { margin: 6px 0 2px; font-size: 13px; color: var(--text2); }

.note {
  margin: 12px 0 0;
  padding-top: 10px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text2);
  border-top: 1px solid var(--border);
}
